import * as modelsGet from "../models/get";
import { getCurrentUser } from "../api/accounts";
import { getUsers } from "../api/users";

var currentUser: modelsGet.IUser;
var users: modelsGet.IUser[];

/**
 * Gibt den momentan angemeldeten Benutzer zurück.
 * @param reload Angabe, ob der Benutzer erneut aus der Datenbank geladen werden soll.
 */
export async function getCurrentUserAsync(reload: boolean = false): Promise<modelsGet.IUser>
{
    if (currentUser == null || reload)
    {
        currentUser = await getCurrentUser();
    }

    return currentUser;
}

/**
 * Gibt alle Benutzer zurück.
 * @param reload Angabe, ob alle Benutzer erneut aus der Datenbank geladen werden soll.
 */
export async function getUsersAsync(reload: boolean = false): Promise<modelsGet.IUser[]>
{
    if (users == null || reload)
    {
        users = await getUsers();
    }

    return users;
}